import React, { useState } from 'react';
import NewLicense from './components/NewLicense';
import EditLicense from './components/EditLicense';
import LicensesList from './components/LicensesList';
import { Col, Container, Row } from 'react-bootstrap';

const Licenses = () => {
  const [listRequiresReload, setListRequiresReload] = useState(true);
  const [selectedLicense, setSelectedLicense] = useState();

  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Licenses Management</h3>
          <h3 className="page-subhead subhead">Manage workspace licenses</h3>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <LicensesList setSelectedLicense={setSelectedLicense} setListRequiresReload={setListRequiresReload} selectedLicense={selectedLicense} listRequiresReload={listRequiresReload} />
        </Col>
        <Col md={4}>
          {!selectedLicense && <NewLicense setSelectedLicense={setSelectedLicense} setListRequiresReload={setListRequiresReload} selectedLicense={selectedLicense} />}
          {selectedLicense && <EditLicense setSelectedLicense={setSelectedLicense} setListRequiresReload={setListRequiresReload} selectedLicense={selectedLicense} />}
        </Col>
      </Row>
    </Container>
  );
};

export default Licenses;